import React, { FC, CSSProperties } from "react"

import { Link } from "src/components/common/link"

import { create } from "src/helpers/bem"
import {
  GET_FOOTER,
  GET_FOOTER_footerMenu1_edges_node_menuItems_nodes,
} from "src/types/wordpress/generated/GET_FOOTER"

import styles from "./Footer.module.scss"

const bem = create(styles, "Footer")

export interface FooterStyleProps extends CSSProperties {
  "--footer-background": string
  "--footer-border-top-color": string
}

export const Footer: FC<GET_FOOTER> = ({
  themeOptions,
  footerMenu1,
  footerMenu2,
  footerMenu3,
}) => {
  const props = themeOptions?.footer
  if (!props) {
    return null
  }
  const { extended, border, logo, socialIcons, backgrounds, copyright } = props

  const modifiers = {
    "is-small": !extended,
  }

  const renderMenu = (
    title: string | null,
    nodes:
      | (GET_FOOTER_footerMenu1_edges_node_menuItems_nodes | null)[]
      | null
      | undefined,
  ) => {
    return (
      <div className={bem("column")}>
        {extended ? (
          <h4 className={bem("navigation__headline")}>{title}</h4>
        ) : null}
        {nodes && nodes?.length > 0 ? (
          <ul className={bem("navigation")}>
            {nodes?.map((el, i) => (
              <li key={`navigation-${i}`} className={bem("navigation__item")}>
                <Link
                  href={el?.connectedNode?.node?.uri ?? el?.url ?? "#"}
                  target={getTarget(el)}
                  classNames={{
                    label: bem("navigation__item__label"),
                    link: bem("navigation__item__link"),
                  }}
                >
                  {el?.label}
                </Link>
              </li>
            ))}
          </ul>
        ) : null}
      </div>
    )
  }

  const getTarget = (
    el: GET_FOOTER_footerMenu1_edges_node_menuItems_nodes | null,
  ) => {
    if (el?.connectedNode?.node?.uri) {
      return el?.target ?? "_self"
    }

    if (el?.url && !el?.url.includes(window.location.host)) {
      return "_blank"
    }

    return "_self"
  }

  return (
    <footer className={bem(undefined, modifiers)}>
      <div className={bem("columns", "left")}>
        <div className={bem("column")}>
          {logo?.url?.url ? (
            <a href={logo.url?.url ?? ""} target={logo?.url?.target ?? "_self"}>
              <img
                alt={logo?.alt ?? ""}
                className={bem("logo__image")}
                src={logo?.src ?? ""}
              />
            </a>
          ) : (
            <img
              alt={logo?.alt ?? ""}
              className={bem("logo__image")}
              src={logo?.src ?? ""}
            />
          )}
        </div>
        {footerMenu1
          ? renderMenu(
              footerMenu1?.edges?.[0]?.node?.name ?? "",
              footerMenu1?.edges?.[0]?.node?.menuItems?.nodes,
            )
          : null}
        {footerMenu2 && extended
          ? renderMenu(
              footerMenu2?.edges?.[0]?.node?.name ?? "",
              footerMenu2?.edges?.[0]?.node?.menuItems?.nodes,
            )
          : null}
        {footerMenu3 && extended
          ? renderMenu(
              footerMenu3?.edges?.[0]?.node?.name ?? "",
              footerMenu3?.edges?.[0]?.node?.menuItems?.nodes,
            )
          : null}
      </div>
      <div className={bem("columns", "right")}>
        <div className={bem("column")}>
          <p className={bem("subtitle", modifiers)}>{copyright}</p>
        </div>
        <div className={bem("column")}>
          <div className={bem("subtitle")}>
            <p>{"HOSTING THE WORLD."}</p>
            <p className={bem("subtitle__bold")}>{"AND YOU."}</p>
          </div>
        </div>
      </div>
    </footer>
  )
}
